import { WatchlistModel } from '@model/DxTrade.types'

export const sortWatchlistsByOrder = (list: WatchlistModel[]) =>
  [...list].sort((a, b) => (a.orderValue ?? 0) - (b.orderValue ?? 0))

export const moveWatchlist = (list: WatchlistModel[], from: number, to: number) => {
  const next = [...list]
  const [item] = next.splice(from, 1)

  if (!item) {
    return list
  }

  next.splice(to, 0, item)

  return next
}
